import { render, staticRenderFns } from "./edit-sisterQuestionUs.vue?vue&type=template&id=65e84b18&scoped=true&"
import script from "./edit-sisterQuestionUs.vue?vue&type=script&lang=ts&"
export * from "./edit-sisterQuestionUs.vue?vue&type=script&lang=ts&"
import style0 from "./edit-sisterQuestionUs.vue?vue&type=style&index=0&id=65e84b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e84b18",
  null
  
)

export default component.exports